/**
 * =============================================================================
 * back-in-stock.js 
 * =============================================================================
 * Helper for custom BIS integration
 * =============================================================================
 */

var BackInStock = {
  selectors: {
    button: "#back-in-stock-form button",
    email_field: "#back-in-stock-form input[type='email']",
    accepts_marketing_field: "#back-in-stock-form input[type='checkbox']:checked",
    response_container: "#back-in-stock-response-container",
    response_message: "#back-in-stock-response"
  },

  onReady: function() {
    $(this.selectors.button).on('click', this.handleBISFormSubmitted.bind(this));
  },

  handleBISFormSubmitted: function(e) {
    e.preventDefault();
    var variantId = MP.Utilities.getVariantId();
    var productId = MP.Utilities.getProductId();
    var email = $(this.selectors.email_field).val();
    var acceptsMarketing = $(this.selectors.accepts_marketing_field).length > 0;
    var attributes = { accepts_marketing: acceptsMarketing };
    console.log("[BIS]", variantId, productId, email, attributes);
    BIS.create(email, variantId, productId, attributes).then(this.handleBISResponse.bind(this));
  },

  handleBISResponse: function(resp) {
    $(this.selectors.response_container).removeClass("alert alert-danger alert-success mt-3");
    switch(resp.status){
      case "Error":
        $(this.selectors.response_container).addClass("alert alert-danger mt-3");
        var errors = [];
        Object.keys(resp.errors).forEach(function(k){
          errors = errors.concat(resp.errors[k]);
        });
        $(this.selectors.response_message).text(errors.join(', '));
        break;
      case "OK":
        $(this.selectors.response_container).addClass("alert alert-success mt-3");
        $(this.selectors.response_message).text(resp.message);
        $(this.selectors.button).prop("disabled", true);
        $(this.selectors.button).text("Registered!");
        break;
    }
  }
};

export default BackInStock;